import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { auth } from '@/api/auth'
import { BASE_URL } from '@/api/api'

class RequestAttachmentService extends AttachmentResource {
    async addAttachment(laboratoryId, requestId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/laboratories/${laboratoryId}/requests/${requestId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })
        return response.data
    }

    async getAttachments(laboratoryId, requestId, attachmentTypeId) {
        const params = { attachmentTypeId }
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/requests/${requestId}/attachments`, { params })
        return response.data
    }

    async getFile(laboratoryId, requestId, attachmentId) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/requests/${requestId}/attachments/${attachmentId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    getUrlFile(laboratoryId, requestId, attachmentId) {
        return `${BASE_URL}/common/laboratories/${laboratoryId}/requests/${requestId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    async deleteAttachment(laboratoryId, requestId, attachmentId) {
        const response = await this.axios.delete(`/common/laboratories/${laboratoryId}/requests/${requestId}/attachments/${attachmentId}`)
        return response.data
    }
}

export default new RequestAttachmentService()
